import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
// import reportWebVitals from './reportWebVitals';
import {ToastContainer} from "react-toastify";
import {Provider} from 'react-redux';
import {PersistGate} from 'redux-persist/integration/react';
import store, {persistor} from './redux/store';
import {TonConnectUIProvider} from '@tonconnect/ui-react';
import {THEME} from '@tonconnect/ui';
import 'react-toastify/dist/ReactToastify.css';
import {GoogleReCaptchaProvider} from 'react-google-recaptcha-v3';

function isTonConnectSdkError(error) {
    const tonConnectError = 'TON_CONNECT_SDK';
    if (typeof error === 'string') {
        return error.includes(tonConnectError);
    }

    return error.message?.includes(tonConnectError);
}

window.addEventListener('unhandledrejection', function (rejection) {
    // handle rejection
    if (isTonConnectSdkError(rejection.reason)) {
        // ignore TonConnect sdk errors, they are handlded by sentry
    }
});
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <Provider store={store}>
        <PersistGate persistor={persistor}>
            <GoogleReCaptchaProvider
                reCaptchaKey="6Le4tEwoAAAAAPSWKChZp5GpzSXQn8cJj7jzFxvJ"
                container={{
                    parameters: {
                        badge: 'bottomright',
                        theme: 'dark',
                    }
                }}
            >
                <TonConnectUIProvider
                    manifestUrl="https://jet.jace.team/tonconnect-manifest.json"
                    uiPreferences={{
                        borderRadius: 'm',
                        colorsSet: {
                            [THEME.DARK]: {
                                connectButton: {
                                    background: '#019A59'
                                },
                                connectedButton: {
                                    background: '#019A59'
                                },
                            },
                            [THEME.LIGHT]: {
                                connectButton: {
                                    background: '#019A59'
                                },
                                connectedButton: {
                                    background: '#019A59'
                                },
                                text: {
                                    fontWeight: 100
                                }
                            },
                        }
                    }}
                >
                    <App />
                </TonConnectUIProvider>
            </GoogleReCaptchaProvider>
            <ToastContainer />
        </PersistGate>
    </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
